import React, { Fragment } from "react";
import Form from "../common/Form";
import Row from "../common/Row";
import Section from "../common/Section";
import * as types from "../../constants/ComponentConstants";


const SportenOpHetWerkBevestigingForm = () => {

    return (
        <Section title={"Bedankt!"} color={types.COLOR_BLUE}>
            <Fragment>
                <Form
                    name="SportenOpHetWerk"
                    isNotRequired
                    headerVisible={false}>
                    <div style={{ padding: "5% 10% 0 10%" }}>
                        <Row>
                            <p>Bedankt voor je aanvraag, de eerste stap naar een sportieve en gezonde werksfeer is gezet!
                                Sport Vlaanderen neemt spoedig contact met je op.</p>
                        <br />
                        <br />
                        <br />
                            <p>Team Sportieve Werkplek</p>
                            <p><b>Sport Vlaanderen</b></p>
                        </Row>
                    </div>
                </Form>
            </Fragment>
        </Section>
    );
};

SportenOpHetWerkBevestigingForm.propTypes = {
};

export default SportenOpHetWerkBevestigingForm;